import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCheckCircleComponent } from "./med-icon-check-circle.component";

@NgModule({
  declarations: [
    MedIconCheckCircleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCheckCircleComponent,
  ],
})
export class MedIconCheckCircleModule { }
